import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SalesPeopleService } from "../salespeople.service";
import { NgxSpinnerService } from "ngx-spinner";
  
@Component({
    selector: 'app-showruleadjustmenthistory-screen',
    templateUrl: './showruleadjustmenthistory.screen.component.html',
    styleUrls: ['./showruleadjustmenthistory.screen.component.scss'],
    providers: [SalesPeopleService],
    standalone: false
})
export class ShowRuleAdjustmenthistoryScreenComponent implements OnInit {
  @Input() historicalData: any; // Historical data passed from the parent component
  parsedHistory: any[] = [];
  isLoading: boolean = true;

constructor(
  private activeModal: NgbActiveModal,
  private _salesPeopleService: SalesPeopleService,
  private spinner: NgxSpinnerService,
) {}

ngOnInit(): void {
  this.showHistory();
}
closePopup() {
  this.activeModal.close({});
}

showHistory() {
  const data = {
        historyId: this.historicalData.historyId,
        historyType: this.historicalData.historyType,
      };

      this._salesPeopleService.getRuleAdjustmentHistoricalChanges(data).subscribe(
        (response) => {
          const history = response.data;
    
          // Parse the JSON string inside `historyData` field
          this.parsedHistory = history.map(item => ({
            ...item,
            historyData: typeof item.historyData === 'string'? JSON.parse(item.historyData) : item.historyData
          }));
          this.isLoading = false; // <- turn off loading
          // this.spinner.hide();
        },
        (error) => {
          console.error("Error fetching historical data:", error);
          this.isLoading = false; // <- turn off loading
          // this.spinner.hide();
        }
      );
}

}